import {BASE_URL} from '../../config/config';
import VideoStreamRenderer from "./Video/VideoStreamRendererComponent";
import ImageSteamRenderer from "./ImageStreamRendererComponent";
import DocumentViewerComponent from "./DocumentViewerComponent";
import PDFViewerComponent from "./PDF/PDFViewerComponent";

const docTypes = ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];

const MediaRendererComponent = ( { file, type }) => {
    let path;

    if (type === 'files') {
        path = `/files/${file.id}`;
    } else if (type === 'links') {
        path = `/files/links/${file.id}`;
    } else if (type === 'public_links') {
        path = `/public/files/links/${file.id}`;
    }
    else {
        throw new Error("Invalid specifier.");
    }

    if (file.contentType.startsWith('image/')) {
        return (
            <ImageSteamRenderer
                url={`${BASE_URL}${path}`}
                fileMeta={file}
            />
        );
    }

    if (file.contentType.startsWith('video/')) {
        return (
            <VideoStreamRenderer
                url={`${BASE_URL}${path}`}
                fileMeta={file}
            />
        )
    }

    if (file.contentType.startsWith('application/PDF')) {
        return <PDFViewerComponent url={`${BASE_URL}${path}`} />
    }

    if (docTypes.includes(file.contentType)) {
        return <DocumentViewerComponent fileUrl={`${BASE_URL}${path}`} />
    }
}

export default MediaRendererComponent;
